module.exports = function getResource(label, vars = []) {
    let resources = {
        justArrived: 'Just Arrived',
        bestsellers: 'Bestsellers'
    };

    return resources[label];
};
